module.exports = __webpack_public_path__ + "img/39_4.a5a2e67b.png";